
import Modal from "@/components/base/modal/Modal"
import SchoolBaseSearch from "@/components/search/SchoolBaseSearch"
export default {
    name: "SchoolBaseInput",
    components: { SchoolBaseSearch, Modal },
    emits: ["change"],
    model: {
        prop: "school",
        event: "change",
    },
    props: {
        /** label of the input field */
        label: {
            type: String,
            default: "Schule",
        },
        /** school object: { id, name } */
        school: {
            type: Object,
            default: null,
        },
        /** display the prepend icon of the activator input */
        showIcon: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            schoolName: "",
            isModalOpen: false,
        }
    },
    created() {
        if (this.school?.name) this.schoolName = this.school.name
    },
    methods: {
        onSchoolSelected(school) {
            this.isModalOpen = false
            this.schoolName = school.name
            this.$emit("change", school)
        },
        onInputClick() {
            this.isModalOpen = true
        },
    },
}
